import { render } from "./ElementProperties.vue?vue&type=template&id=1e764684&scoped=true&ts=true"
import script from "./ElementProperties.vue?vue&type=script&lang=ts"
export * from "./ElementProperties.vue?vue&type=script&lang=ts"

import "./ElementProperties.vue?vue&type=style&index=0&id=1e764684&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e764684"]])

export default __exports__